<template>
  <div class="TabsHead">
    <div class="tabsList">
      <Tab
        v-for="(label, index) in labels"
        :key="label"
        :isActive="labelActiveInner === label"
        @click="set(index, label)">
        {{ label }}
        <slot
          :index="index"
          :isActive="labelActiveInner === label"
          name="tabSuffix" />
      </Tab>
    </div>
    <slot />
  </div>
</template>

<script>
import Tab from '@components/Tab'

export default {
  components: { Tab },
  props: {
    indexActive: Number,
    labelActive: String,
    labels: Array,
  },
  computed: {
    labelActiveInner() {
      if (typeof this.indexActive !== 'number') return this.labelActive

      return this.labels[this.indexActive]
    },
  },
  methods: {
    set(index, label) {
      this.$emit('update:indexActive', index)
      this.$emit('update:labelActive', label)
    },
  },
}
</script>

<style lang="scss">
.TabsHead {
  align-items: flex-start;
  border-bottom: 1px solid $border-color;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  > .tabsList {
    width: 100%;
  }
}
</style>
